module.exports = __webpack_public_path__ + "img/medication.6b2e04ff.jpg";